export const WallElectricalDetails = [
  {
    id: 'sow_hl_scope',
    label: 'SOW in HL Scope',
    options: [
      {
        id: 'sow_hl_scope_first_tab',
        label: '',
        type: 'option',
        options: ['Light Supply', 'Switch & Sockets', 'Looping']
      },
      {
        id: 'sow_hl_scope_second_tab',
        label: '',
        type: 'option',
        options: ['Light Supply', 'Switch & Sockets', 'Looping']
      },
      {
        id: 'sow_hl_scope_third_tab',
        label: '',
        type: 'option',
        options: ['Light Supply', 'Switch & Sockets', 'Looping']
      },
    ],
  },
  {
    id: 'sow_cx_scope',
    label: 'SOW in CX Scope',
    options: [
      {
        id: 'sow_cx_scope_first_tab',
        label: '',
        type: 'option',
        options: ['Light Supply', 'Switch & Sockets', 'Looping']
      },
      {
        id: 'sow_cx_scope_second_tab',
        label: '',
        type: 'option',
        options: ['Light Supply', 'Switch & Sockets', 'Looping']
      },
      {
        id: 'sow_cx_scope_third_tab',
        label: '',
        type: 'option',
        options: ['Light Supply', 'Switch & Sockets', 'Looping']
      },
    ],
  },
];

export const WallElectricalModification = [
  {
    id: 'brand',
    brand: '',
  }, 
  {
    id: 'description',
    description: '',
  }, 
  {
    id: 'type',
    type: '',
  },
  {
    id: 'module',
    module: '',
    options: ['2 Module', '3 Module', '4 Module', '6 Module', '8 Module', '10 Module', '12 Module', '16 Module']
  },
  {
    id: 'brand_2',
    brand: '',
  }, 
  {
    id: 'description_2',
    description: '',
  }, 
  {
    id: 'type_2',
    type: '',
  },
  {
    id: 'module_2',
    module: '',
    options: ['2 Module', '3 Module', '4 Module', '6 Module', '8 Module', '10 Module', '12 Module', '16 Module']
  },
  {
    id: 'brand_3',
    brand: '',
  },
  {
    id: 'description_3',
    description: '',
  }, 
  {
    id: 'type_3',
    type: '',
  },
  {
    id: 'module_3',
    module: '',
    options: ['2 Module', '3 Module', '4 Module', '6 Module', '8 Module', '10 Module', '12 Module', '16 Module']
  },
  {
    id: 'brand_4',
    brand: '',
  }, 
  {
    id: 'description_4',
    description: '',
  }, 
  {
    id: 'type_4',
    type: '',
  },
  {
    id: 'module_4',
    module: '',
    options: ['2 Module', '3 Module', '4 Module', '6 Module', '8 Module', '10 Module', '12 Module', '16 Module']
  },
  {
    id: 'brand_5',
    brand: '',
  }, 
  {
    id: 'description_5',
    description: '',
  }, 
  {
    id: 'type_5',
    type: '',
  },
  {
    id: 'module_5',
    module: '',
    options: ['2 Module', '3 Module', '4 Module', '6 Module', '8 Module', '10 Module', '12 Module', '16 Module']
  }
]

export const ElectricalSOW = [
  {
    id: 'light_installation_by',
    label: 'Light Installation by',
    options: ['CX Scope', 'HL Scope']
  },
  {
    id: 'wiring_looping_by',
    label: 'Wiring / Looping by',
    options: ['CX Scope', 'HL Scope']
  },
  {
    id: 'switch_box_addition_point',
    label: 'Creation of Switch box / Addition of point',
    options: ['CX Scope', 'HL Scope']
  },
  {
    id: 'supply_switch_plates_switches',
    label: 'Supply of Switch plates / switches',
    options: ['CX Scope', 'HL Scope']
  }
]

export const WoodenFlooringDetails = [
  {
    id: 'pattern',
    pattern: '',
    options: ['Brick', 'Herringbone', 'Random']
  }, 
  {
    id: 'collection',
    collection: '',
  },
  {
    id: 'name',
    name: '',
  },
  {
    id: 'brand',
    brand: '',
  },
  {
    id: 'qty',
    qty: '',
  }
]

export const floorLayingPattern = [
  { name: "Brick", value: "BRICK", image: "https://d18w0now3310fo.cloudfront.net/assets/misc/brick.png" },
  { name: "Herringbone", value: "HERRING_BONE", image: "https://d18w0now3310fo.cloudfront.net/assets/misc/Herringbone.png" },
  { name: "Random", value: "RANDOM", image: "" }
];


export const WallPaintModification = [
  {
    id: 'first_row_tagging',
    tagging: ''
  },
  {
    id: 'first_row_type',
    type: '',
  },
  {
    id: 'first_row_name',
    name: '',
  },
  {
    id: 'first_row_brand',
    brand: ''
  },
  {
    id: 'first_row_color',
    color: ''
  },
  {
    id: 'first_row_qty',
    qty: ''
  },
  {
    id: 'second_row_tagging',
    tagging: ''
  },
  {
    id: 'second_row_type',
    type: '',
  },
  {
    id: 'second_row_name',
    name: '',
  },
  {
    id: 'second_row_brand',
    brand: ''
  },
  {
    id: 'second_row_color',
    color: ''
  },
  {
    id: 'second_row_qty',
    qty: ''
  },
  {
    id: 'third_row_tagging',
    tagging: ''
  },
  {
    id: 'third_row_type',
    type: '',
  },
  {
    id: 'third_row_name',
    name: '',
  },
  {
    id: 'third_row_brand',
    brand: ''
  },
  {
    id: 'third_row_color',
    color: ''
  },
  {
    id: 'third_row_qty',
    qty: ''
  },
  {
    id: 'fourth_row_tagging',
    tagging: ''
  },
  {
    id: 'fourth_row_type',
    type: '',
  },
  {
    id: 'fourth_row_name',
    name: '',
  },
  {
    id: 'fourth_row_brand',
    brand: ''
  },
  {
    id: 'fourth_row_color',
    color: ''
  },
  {
    id: 'fourth_row_qty',
    qty: ''
  },
  {
    id: 'fifth_row_tagging',
    tagging: ''
  },
  {
    id: 'fifth_row_type',
    type: '',
  },
  {
    id: 'fifth_row_name',
    name: '',
  },
  {
    id: 'fifth_row_brand',
    brand: ''
  },
  {
    id: 'fifth_row_color',
    color: ''
  },
  {
    id: 'fifth_row_qty',
    qty: ''
  },
]